module.exports = __webpack_public_path__ + "img/1723012201603-WhatsApp Image 2024-08-01 at 18.58.56.jpeg.cd7da1fc.webp";